import React from 'react';
import './MarkAppFooter.css';

const MarkAppFooter = () => {
    return (
        <footer className="markapp-footer">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-column">
                        <div className="footer-logo">
                            <img src="/markapp-logo.png" alt="MarkApp" className="footer-logo-image" />
                        </div>
                        <p className="footer-description" style={{ textAlign: 'left' }}>
                            Первое iOS приложение для автоматической маркировки рекламы в Telegram.
                        </p>
                        <div className="footer-socials">
                            <a href="https://t.me/promarkapp" className="social-link" target="_blank" rel="noopener noreferrer">Telegram</a>
                        </div>
                    </div>

                    <div className="footer-column">
                        <h4 className="footer-title">Продукт</h4>
                        <ul className="footer-links">
                            <li><a href="https://markapp.pro#features">Возможности</a></li>
                            <li><a href="https://markapp.pro#pricing">Тарифы</a></li>
                            <li><a href="/help">Помощь</a></li>
                            <li><a href="https://markapp.pro#faq">FAQ</a></li>
                            <li><a href="/docs">Документация</a></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h4 className="footer-title">Компания</h4>
                        <ul className="footer-links">
                            <li><a href="https://markapp.pro/about.html">О нас</a></li>
                            <li><a href="https://markapp.pro/contacts.html">Контакты</a></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h4 className="footer-title">Контакты</h4>
                        <ul className="footer-links">
                            <li><a href="mailto:support@markapp.ru">support@markapp.ru</a></li>
                            <li>Россия</li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p className="footer-copy">© 2025 MarkApp. Все права защищены.</p>
                    <div className="footer-legal">
                        <a href="https://markapp.pro/privacy-policy.html">Политика конфиденциальности</a>
                        <a href="https://markapp.pro/terms-of-service.html">Условия использования</a>
                        <a href="https://markapp.pro/oferta.html">Договор оферты</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default MarkAppFooter;

